import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from '../utils/mock';
import { UpdateUserTaskParams, UpdateUserTaskResponse } from './types';
import { mockUpdateUserTaskResponse } from './mockData';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const updateUserTask: MutationFunction<
  UpdateUserTaskResponse,
  UpdateUserTaskParams[]
> = async (args) => {
  if (isMockServices()) {
    return await mock(mockUpdateUserTaskResponse, {
      delay: 1000,
      failureRate: 0,
    });
  }

  const requestBody = args.map((x) => {
    const { id, ...updateData } = x;
    const { targetCompletionDate, ...restData } = updateData;
    return {
      id,
      ...restData,
      ...('targetCompletionDate' in updateData && {
        targetCompletionDate: targetCompletionDate?.toISOString() ?? null,
      }),
    };
  });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateUserTaskResponse>(
    `/userTasks/bulk`,
    {
      method: 'PUT',
      body: {
        tasks: requestBody,
      },
    },
  );

  if (response.data) return response.data;

  throw new Error('Failed to update user task');
};

export default updateUserTask;
